import ApiRest from '@/api/api-rest'
import ProcessData from '@/resources/models/ProcessData'
import {
  TRAIL_PROCESS_GRAPH_REQ,
  TRAIL_PROCESS_PATH_ARTIFACTS_REQ,
  TRAIL_PROCESS_NETWORK_ARTIFACTS_REQ
} from './trailsinfo.type'

const state = {}
const getters = {}
const mutations = {}
const actions = {
  [TRAIL_PROCESS_GRAPH_REQ] (context, params) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/bi/trails/graph/${params.platform}/${params.agentId}/${params.trailId}/${params.offset}`)
        .then(({ data }) => {
          resolve(new ProcessData(params.trailId, data))
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [TRAIL_PROCESS_PATH_ARTIFACTS_REQ] (context, params) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/bi/trails/graph/artifacts/${params.agentId}/${params.trailId}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [TRAIL_PROCESS_NETWORK_ARTIFACTS_REQ] (context, params) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/bi/trails/graph/network/${params.agentId}/${params.trailId}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailgraph.module.js